import { URL_TYPES } from '@wix/wix-vod-constants/common';
const ID_REGEXP = '([\\w\\-]+)';
const CHANNEL_PATTERNS = {
    [URL_TYPES.PLAYLIST]: [new RegExp(`youtube\\.com\\/.*list=${ID_REGEXP}`)],
    [URL_TYPES.CHANNEL]: [
        new RegExp(`youtube\\.com\\/(channel|c|@)\\/?([\\w\\-%]+)`),
    ],
    [URL_TYPES.USER_NAME]: [new RegExp(`youtube\\.com\\/user\\/${ID_REGEXP}`)],
};
const VIDEO_PATTERNS = {
    ...CHANNEL_PATTERNS,
    [URL_TYPES.VIDEO]: [
        new RegExp(`youtu\\.be\\/${ID_REGEXP}`),
        new RegExp(`youtube\\.com\\/watch\\?.*v=${ID_REGEXP}`),
        new RegExp(`youtube\\.com\\/(?:v|embed)\\/${ID_REGEXP}`),
    ],
};
const findFirstMatchedId = (regexps, url) => {
    for (const regexp of regexps) {
        const res = regexp.exec(url);
        if (res) {
            return res[res.length - 1];
        }
    }
    return null;
};
const findMatch = (patterns, url) => {
    let type;
    for (type in patterns) {
        const regexps = patterns[type];
        const id = regexps ? findFirstMatchedId(regexps, url) : null;
        if (id) {
            return { id, type };
        }
    }
    return null;
};
function searchByPattern(patterns, url) {
    const result = findMatch(patterns, url);
    if (!result) {
        throw new Error(`Given url doesn't match any pattern`);
    }
    return result;
}
function parseChannelUrl(url) {
    return searchByPattern(CHANNEL_PATTERNS, url);
}
function parseVideoUrl(url) {
    return searchByPattern(VIDEO_PATTERNS, url);
}
export { parseChannelUrl, parseVideoUrl };
//# sourceMappingURL=parse-url.js.map